import { onCLS, onFID, onLCP, onINP } from 'web-vitals';

export const coreWebVitals = sendMetric => {
  const processMetric = ({ value }, stage) =>
    sendMetric({ stage, duration: value });

  onCLS(metrics => processMetric(metrics, 'cumulativeLayoutShift'));
  onFID(metrics => processMetric(metrics, 'firstInputDelay'));
  onLCP(metrics => processMetric(metrics, 'largestContentfulPaint'));
  onINP(metrics => processMetric(metrics, 'interactionToNextPaint'));
};



// WEBPACK FOOTER //
// ./src/metrics/lib/coreWebVitals.js